<template>
  <div class="pb100">
    <banner/>
    <crumbs/>
    <div class="container">
      <type-screen modelType="information" :menu-id="this.$route.query.columnId" @typeObj="selectType"/>
      <ul class="ul-model2 mt30 clearfix" v-if="modelname === 'model1'">
        <li v-for="(item, index) in List" :key="index">
          <a @click.stop="detaillink(item)" class="clearfix">
            <div class="imgbox">
              <img :src="getImage(item.image)">
            </div>
            <div class="txtbox">
              <h2 class="textover">{{ item.title }}</h2>
              <div class="descstyle">{{ item.remark }}</div>
              <p class="date">{{ item.publishDate }}</p>
            </div>
          </a>
        </li>
      </ul>
      <ul class="ul-model5 clearfix mt20" v-if="modelname === 'model2'">
        <li @click.stop="detaillink(item)" v-for="(item, index) in List" :key="index">
          <a>
            <div class="imgbox">
              <!-- <img class="icon" v-if="item.detailUrl !== undefined && item.detailUrl !== ''" src="../../assets/common/icon/icon-video1.png" alt=""> -->
              <img class="imgtop" :src="getImage(item.image)" alt="">
            </div>
            <div class="txtbox">
              <h2 class="textover">{{ item.title }}</h2>
              <p class="date">{{ item.publishDate }}</p>
              <div class="descbox mt10" v-html="item.remark"></div>
              <span class="more gradientGreenBlue mt10">查看详情</span>
            </div>
          </a>
        </li>
      </ul>
      <nodata v-show="nodataflag"/>
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="informationParam.limit"
        :pager-count="5"
        :current-page.sync="currentPage"
        layout="prev, pager, next"
        :total="listTotal"
        class="pagemodel1">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import crumbs from '@/components/crumbs/index'
import banner from '@/components/banner/index'
import typeScreen from '@/components/typescreen/index'
import { getInformationList } from '@/api/information/index'
import { scrollAnimation } from '@/utils/index'
import nodata from '@/components/nodata/index'
import { getfrontslot } from '@/api/userservice/index'
export default {
  name: 'information',
  meta: {
    showHeader: true
  },
  components: {
    typeScreen,
    crumbs,
    nodata,
    banner
  },
  data () {
    return {
      informationParam: {
        page: 1,
        limit: 12,
        columnId: this.$route.query.columnId,
        types: '',
        infoType: '',
        codes: ''
      },
      currentPage: 1,
      nodataflag: false,
      List: [],
      listTotal: 0,
      modelname: 'model1',
      slotList: [],
      params: {
        museumCode: this.$cookie.get('museumCode'),
        slotName: 'information',
        slotCode: ''
      }
    }
  },
  mounted () {
    this.getSlot()
  },
  methods: {
    getSlot () {
      getfrontslot(this.params).then(res => {
        if (res.data.status === 200) {
          res.data.data.rows[0].adDetails.forEach(item => {
            if (parseInt(item.adName) === parseInt(this.$route.query.columnId)) {
              this.modelname = item.adDesc
            }
          })
        }
      })
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    // 获取新闻列表
    getInformation () {
      getInformationList(this.informationParam).then((res) => {
        if (res.data.list.status === 200) {
          this.listTotal = res.data.list.data.total
          if (this.listTotal === 0) {
            this.nodataflag = true
          } else {
            this.nodataflag = false
          }
          this.List = res.data.list.data.rows
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    /* 筛选条件 */
    selectType (obj) {
      this.informationParam.infoType = obj.infoType
      if (obj.codes !== undefined) {
        this.informationParam.codes = obj.codes.toString()
      }
      this.informationParam.types = obj.customTypeId
      this.informationParam.page = 1
      this.currentPage = 1
      if (this.$cookie.get('museumCode') === 'xalt' && parseInt(this.$route.query.columnId) === 6176) {
        if (obj.codes.length === 1 && obj.codes[0] === 'xatsg') {
          this.informationParam.columnId = 6197
        } else {
          this.informationParam.columnId = this.$route.query.columnId
        }
      }
      this.getInformation()
    },
    // 分页触发
    handleCurrentChange (val) {
      this.informationParam.page = val
      const currentY = document.documentElement.scrollTop || document.body.scrollTop
      scrollAnimation(currentY, 0)
      this.getInformation()
    },
    detaillink (item) {
      if (item.link !== undefined && item.link !== '') {
        window.open(item.link)
      } else {
        if (this.$route.query.subhomepage !== undefined) {
          this.$router.push({path: '/informationdetail', query: {columnId: item.columnId, id: item.id, subhomepage: this.$route.query.subhomepage}})
        } else {
          this.$router.push({path: '/informationdetail', query: {columnId: item.columnId, id: item.id}})
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/view/information/list.vue